import api from "./axios";

// Admin-tunable server settings (key/value).
export const getSettings = () => api.get("/settings");
export const updateSettings = (payload) => api.put("/settings", payload);
